/**
 * Botón redondo para abrir el panel de actividades
 * Disponible para profesores y estudiantes
 */

import './ActivitiesButton.css';

interface ActivitiesButtonProps {
  onClick: () => void;
  title?: string;
}

export function ActivitiesButton({ onClick, title = "Mis Actividades" }: ActivitiesButtonProps) {
  return (
    <button
      className="activities-button"
      onClick={onClick}
      aria-label={title}
      title={title}
    >
      <img 
        src="/assets/ui/iconos/Actividades.png" 
        alt={title}
        className="activities-icon"
      />
    </button>
  );
}
